/* eslint-disable no-shadow */
import SearchServiceClient from '@/api/SearchServiceClient';

const state = () => ({
  badges: {},
});

const mutations = {
  SET_BADGES(state, badges) {
    state.badges = {
      ...state.badges,
      ...badges,
    };
  },
  CLEAR_BADGES(state) {
    state.badges = {};
  },
};

const actions = {
  async fetchBadges({ commit }, { auctionIds, filters, savedSearchIds }) {
    if (!auctionIds.length) return;

    const client = new SearchServiceClient();
    const response = await client.getAuctionBadges({
      auctionIds,
      filters,
      savedSearchIds,
    });

    // Normalize response: API returns a single badge object per auction (snake_case),
    // we store as an array of camelCase badge objects per auction ID
    const normalized = {};
    const raw = response.data;
    Object.keys(raw).forEach((auctionId) => {
      const entry = raw[auctionId];
      if (!entry) return;
      // Support both single object and array from API
      const badges = Array.isArray(entry) ? entry : [entry];
      normalized[auctionId] = badges.map((b) => ({
        auctionBadge: b.auction_badge,
        auctionBadgeTitle: b.auction_badge_title || null,
        auctionBadgeTooltip: b.auction_badge_tooltip || null,
      }));
    });
    commit('SET_BADGES', normalized);
  },
  clearBadges({ commit }) {
    commit('CLEAR_BADGES');
  },
};

const getters = {
  getBadgesForAuction: (state) => (auctionId) => state.badges[auctionId] || [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
